import CustomField from 'elements/field/CustomField'
import React from 'react'
import { SelectInput, useTranslate } from 'react-admin'
import { SNOW_MODE_DYNAMIC, SNOW_MODE_FIXED_PERCENTAGE } from './constants'
import { SnowSimulationModeTooltip } from './SnowSimulationModeTooltip'

interface SnowSimulationModeFieldProps {
  allowEdit: boolean
  canUseDynamicMode: boolean
  style: React.CSSProperties
}

export const SnowSimulationModeField: React.FC<SnowSimulationModeFieldProps> = ({
  allowEdit,
  canUseDynamicMode,
  style,
}) => {
  const translate = useTranslate()

  const choices = [
    { id: SNOW_MODE_FIXED_PERCENTAGE, name: translate('Fixed Percentage') },
    { id: SNOW_MODE_DYNAMIC, name: translate('Dynamic'), disabled: !canUseDynamicMode },
  ]

  return (
    <>
      <CustomField
        component={SelectInput}
        source="sam_snow_mode"
        name="sam_snow_mode"
        label="Snow Simulation Mode"
        choices={choices}
        disabled={!allowEdit}
        style={style}
      />
      <SnowSimulationModeTooltip canUseDynamicMode={canUseDynamicMode} />
    </>
  )
}
